import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { FormConfigItem } from '@app/shared/interfaces/form-config-item';
import { ModelAttributes } from '@app/core/interface/common';

@Component({
  selector: 'app-add-contact-form',
  templateUrl: './add-contact-form.component.html',
  styleUrls: ['./add-contact-form.component.sass'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AddContactFormComponent {

  public form;

  @Input() public title: string;

  @Input() public tooltip: string;

  @Input() public formConfig: FormConfigItem[] = [];

  @Output() public submitEvent = new EventEmitter<ModelAttributes>();

  @Output() public cancelEvent = new EventEmitter<void>();

  public submit(): void {
    const model = { ...this.form.value };

    for (const key of Object.keys(model)) {
      if (model[key] === null || model[key] === '') {
        delete model[key];
      }
    }

    this.submitEvent.emit(model);
  }
}
